export default __webpack_public_path__ + "static/media/negative.978e3fe4.svg";